import { Flex } from "@chakra-ui/react";
import React from "react";
import EditFamily from "./components/EditFamily";

function Data() {

  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <EditFamily
      />
    </Flex>
  );
}

export default Data;
